module.exports = __webpack_public_path__ + "static/bluecellular-ce750de67240a8da43de4b4d22ffc53e.jpeg";